// extracted by mini-css-extract-plugin
module.exports =  {"collapse":"almQgtgddSoS_t2cT3xw","content":"IaEasK8wijfpAHe9cb8Q"};